import React, { useEffect, useState } from 'react';
import './Gallery.css';

const Gallery = () => {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState('');
  const [currentTitle, setCurrentTitle] = useState('');

  useEffect(() => {
    // إغلاق lightbox عند الضغط على ESC
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        closeLightbox();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);

  const openLightbox = (src, title) => {
    setCurrentImage(src);
    setCurrentTitle(title);
    setLightboxOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    document.body.style.overflow = 'auto';
  };

  const galleryImages = [
    {
      src: "https://am-herbal.org/wp-content/uploads/2024/08/WhatsApp-Image-2024-08-04-at-19.35.02-2.jpeg",
      title: "WhatsApp Image 2024-08-04 at 19.35.02 (2)",
      width: 720,
      height: 1280,
      type: "portrait"
    },
    {
      src: "https://am-herbal.org/wp-content/uploads/2024/08/WhatsApp-Image-2024-08-04-at-19.35.02-3.jpeg",
      title: "WhatsApp Image 2024-08-04 at 19.35.02 (3)",
      width: 720,
      height: 1280,
      type: "portrait"
    },
    {
      src: "https://am-herbal.org/wp-content/uploads/2024/08/WhatsApp-Image-2024-08-04-at-19.35.02-4.jpeg",
      title: "WhatsApp Image 2024-08-04 at 19.35.02 (4)",
      width: 899,
      height: 1599,
      type: "portrait"
    },
    {
      src: "https://am-herbal.org/wp-content/uploads/2024/08/WhatsApp-Image-2024-08-04-at-19.35.02.jpeg",
      title: "WhatsApp Image 2024-08-04 at 19.35.02",
      width: 899,
      height: 1599,
      type: "portrait"
    },
    {
      src: "https://am-herbal.org/wp-content/uploads/2024/08/WhatsApp-Image-2024-08-04-at-20.05.51.jpeg",
      title: "WhatsApp Image 2024-08-04 at 20.05.51",
      width: 956,
      height: 1280,
      type: "portrait"
    },
    {
      src: "https://am-herbal.org/wp-content/uploads/2024/08/WhatsApp-Image-2024-08-04-at-20.05.52-1.jpeg",
      title: "WhatsApp Image 2024-08-04 at 20.05.52 (1)",
      width: 894,
      height: 1226,
      type: "portrait"
    },
    {
      src: "https://am-herbal.org/wp-content/uploads/2024/08/WhatsApp-Image-2024-08-04-at-20.05.52-2.jpeg",
      title: "WhatsApp Image 2024-08-04 at 20.05.52 (2)",
      width: 986,
      height: 991,
      type: "landscape"
    },
    {
      src: "https://am-herbal.org/wp-content/uploads/2024/08/WhatsApp-Image-2024-08-04-at-20.05.52-3.jpeg",
      title: "WhatsApp Image 2024-08-04 at 20.05.52 (3)",
      width: 695,
      height: 1280,
      type: "portrait"
    },
    {
      src: "https://am-herbal.org/wp-content/uploads/2024/08/WhatsApp-Image-2024-08-04-at-20.05.52.jpeg",
      title: "WhatsApp Image 2024-08-04 at 20.05.52",
      width: 981,
      height: 1119,
      type: "portrait"
    },
    {
      src: "https://am-herbal.org/wp-content/uploads/2024/08/WhatsApp-Image-2024-08-04-at-20.05.53-1.jpeg",
      title: "WhatsApp Image 2024-08-04 at 20.05.53 (1)",
      width: 899,
      height: 1280,
      type: "portrait"
    },
    {
      src: "https://am-herbal.org/wp-content/uploads/2024/08/WhatsApp-Image-2024-08-04-at-20.05.53.jpeg",
      title: "WhatsApp Image 2024-08-04 at 20.05.53",
      width: 850,
      height: 1280,
      type: "portrait"
    },
    {
      src: "https://am-herbal.org/wp-content/uploads/2024/08/1704748144599.jpg",
      title: "1704748144599",
      width: 1280,
      height: 1706,
      type: "portrait"
    },
    {
      src: "https://am-herbal.org/wp-content/uploads/2024/08/1716228786940.jpg",
      title: "1716228786940",
      width: 1280,
      height: 1629,
      type: "portrait"
    },
    {
      src: "https://am-herbal.org/wp-content/uploads/2024/08/1716228788345.jpg",
      title: "1716228788345",
      width: 1280,
      height: 1707,
      type: "portrait"
    },
    {
      src: "https://am-herbal.org/wp-content/uploads/2024/08/1716229043481.jpg",
      title: "1716229043481",
      width: 1280,
      height: 1706,
      type: "portrait"
    },
    {
      src: "https://am-herbal.org/wp-content/uploads/2024/08/1716229048349.jpg",
      title: "1716229048349",
      width: 1280,
      height: 1706,
      type: "portrait"
    },
    {
      src: "https://am-herbal.org/wp-content/uploads/2024/08/1718160307189.jpg",
      title: "1718160307189",
      width: 1280,
      height: 1707,
      type: "portrait"
    },
    {
      src: "https://am-herbal.org/wp-content/uploads/2024/08/1718160308572.jpg",
      title: "1718160308572",
      width: 1280,
      height: 1707,
      type: "portrait"
    },
    {
      src: "https://am-herbal.org/wp-content/uploads/2024/08/1719146491984.jpg",
      title: "1719146491984",
      width: 800,
      height: 1067,
      type: "portrait"
    },
    {
      src: "https://am-herbal.org/wp-content/uploads/2024/08/1722409218196.jpg",
      title: "1722409218196",
      width: 1200,
      height: 1406,
      type: "portrait"
    },
    {
      src: "https://am-herbal.org/wp-content/uploads/2024/08/1722548433315.jpg",
      title: "1722548433315",
      width: 800,
      height: 1066,
      type: "portrait"
    },
    {
      src: "https://am-herbal.org/wp-content/uploads/2024/08/1722548434385.jpg",
      title: "1722548434385",
      width: 800,
      height: 1066,
      type: "portrait"
    },
    {
      src: "https://am-herbal.org/wp-content/uploads/2024/08/1722548442178.jpg",
      title: "1722548442178",
      width: 800,
      height: 1066,
      type: "portrait"
    },
    {
      src: "https://am-herbal.org/wp-content/uploads/2024/08/1722548544030.jpg",
      title: "1722548544030",
      width: 800,
      height: 1066,
      type: "portrait"
    },
    {
      src: "https://am-herbal.org/wp-content/uploads/2024/08/1722548547229.jpg",
      title: "1722548547229",
      width: 800,
      height: 1066,
      type: "portrait"
    },
    {
      src: "https://am-herbal.org/wp-content/uploads/2024/08/WhatsApp-Image-2024-08-04-at-19.34.56.jpeg",
      title: "WhatsApp Image 2024-08-04 at 19.34.56",
      width: 960,
      height: 1280,
      type: "portrait"
    },
    {
      src: "https://am-herbal.org/wp-content/uploads/2024/08/WhatsApp-Image-2024-08-04-at-19.34.58.jpeg",
      title: "WhatsApp Image 2024-08-04 at 19.34.58",
      width: 960,
      height: 1280,
      type: "portrait"
    },
    {
      src: "https://am-herbal.org/wp-content/uploads/2024/08/WhatsApp-Image-2024-08-04-at-19.35.01-1.jpeg",
      title: "WhatsApp Image 2024-08-04 at 19.35.01 (1)",
      width: 528,
      height: 960,
      type: "portrait"
    },
    {
      src: "https://am-herbal.org/wp-content/uploads/2024/08/WhatsApp-Image-2024-08-04-at-19.35.01-2.jpeg",
      title: "WhatsApp Image 2024-08-04 at 19.35.01 (2)",
      width: 899,
      height: 1599,
      type: "portrait"
    },
    {
      src: "https://am-herbal.org/wp-content/uploads/2024/08/WhatsApp-Image-2024-08-04-at-19.35.01.jpeg",
      title: "WhatsApp Image 2024-08-04 at 19.35.01",
      width: 960,
      height: 1280,
      type: "portrait"
    },
    {
      src: "https://am-herbal.org/wp-content/uploads/2024/08/parsf3_zoom.jpg",
      title: "parsf3_zoom",
      width: 1655,
      height: 1203,
      type: "landscape"
    },
    {
      src: "https://am-herbal.org/wp-content/uploads/2024/08/CALENDULA-YELLOW_MATTISON_712072.jpg",
      title: "CALENDULA-YELLOW_MATTISON_712072",
      width: 1536,
      height: 1024,
      type: "landscape"
    },
    {
      src: "https://am-herbal.org/wp-content/uploads/2024/08/ADP170815_3909.webp",
      title: "ADP170815_3909",
      width: 1000,
      height: 1000,
      type: "landscape"
    },
    {
      src: "https://am-herbal.org/wp-content/uploads/2024/08/WhatsApp-Image-2024-08-04-at-01.21.29_3982a7b6.jpg",
      title: "WhatsApp Image 2024-08-04 at 01.21.29_3982a7b6",
      width: 899,
      height: 1599,
      type: "portrait"
    },
    {
      src: "https://am-herbal.org/wp-content/uploads/2024/08/WhatsApp-Image-2024-08-04-at-01.21.29_25d38c5c.jpg",
      title: "WhatsApp Image 2024-08-04 at 01.21.29_25d38c5c",
      width: 899,
      height: 1599,
      type: "portrait"
    },
    {
      src: "https://am-herbal.org/wp-content/uploads/2024/08/WhatsApp-Image-2024-08-04-at-01.20.44_c29b1b42.jpg",
      title: "WhatsApp Image 2024-08-04 at 01.20.44_c29b1b42",
      width: 899,
      height: 1599,
      type: "portrait"
    },
    {
      src: "https://am-herbal.org/wp-content/uploads/2024/08/WhatsApp-Image-2024-08-04-at-01.20.43_043e56bf.jpg",
      title: "WhatsApp Image 2024-08-04 at 01.20.43_043e56bf",
      width: 899,
      height: 1599,
      type: "portrait"
    },
    {
      src: "https://am-herbal.org/wp-content/uploads/2024/08/MJR080808American_141.jpg",
      title: "MJR080808American_141",
      width: 1000,
      height: 700,
      type: "landscape"
    },
    {
      src: "https://am-herbal.org/wp-content/uploads/2024/08/image.jpg",
      title: "image",
      width: 910,
      height: 718,
      type: "landscape"
    }
  ];

  const videos = [
    {
      src: "https://am-herbal.org/wp-content/uploads/2024/08/WhatsApp-Video-2024-08-04-at-01.21.29_3b9ea092.mp4",
      title: "WhatsApp Video 2024-08-04 at 01.21.29"
    },
    {
      src: "https://am-herbal.org/wp-content/uploads/2024/08/WhatsApp-Video-2024-08-04-at-01.21.29_5f395421.mp4",
      title: "WhatsApp Video 2024-08-04 at 01.21.29"
    }
  ];

  return (
    <>
      <div id="Content" role="main">
        <div className="content_wrapper clearfix">
          <div className="sections_group">
            <div className="entry-content" itemprop="mainContentOfPage">
              
              {/* Hero Section */}
              <div className="hero-section">
                <div className="container">
                  <div className="hero-content">
                    <h5 className="hero-subtitle">* Realm of Herbs Company *</h5>
                    <h1 className="hero-title">Our Gallery</h1>
                    <p className="hero-description">
                      Discover our premium collection of medicinal herbs, natural products, and wellness solutions
                    </p>
                  </div>
                </div>
              </div>



              {/* Gallery Grid - مباشرة بعد الفاصل */}
              <div className="gallery-section">
                <div className="container">
                  <div className="section-header">
                    <h2>Photo Gallery</h2>
                    <p>Explore our collection of premium herbal products and facilities</p>
                  </div>
                  <div className="gallery-grid">
                    {galleryImages.map((image, index) => (
                      <div key={index} className="gallery-item" data-title={image.title}>
                        <div className="image-frame">
                          <div className="image-wrapper">
                            <a 
                              href={image.src} 
                              onClick={(e) => {
                                e.preventDefault();
                                openLightbox(image.src, image.title);
                              }}
                            >
                              <div className="image-mask"></div>
                              <img 
                                src={image.src}
                                alt={image.title}
                                loading={index > 5 ? "lazy" : "eager"}
                              />
                            </a>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Videos Section */}
              <div className="videos-section">
                <div className="container">
                  <div className="section-header">
                    <h2>Video Gallery</h2>
                    <p>Watch our herbal products in action</p>
                  </div>
                  <div className="videos-grid">
                    {videos.map((video, index) => (
                      <div key={index} className="video-item">
                        <div className="video-wrapper">
                          <video 
                            poster="" 
                            autoPlay={false}
                            controls={true}
                            loop={false}
                            muted={false}
                          >
                            <source type="video/mp4" src={video.src} />
                            Your browser does not support the video tag.
                          </video>
                          <div className="video-title">{video.title}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Lightbox */}
      {lightboxOpen && (
        <div className="lightbox-overlay" onClick={closeLightbox}>
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <button className="lightbox-close" onClick={closeLightbox}>
              <span>✕</span>
            </button>
            <img src={currentImage} alt={currentTitle} />
            {currentTitle && <div className="lightbox-title">{currentTitle}</div>}
          </div>
        </div>
      )}
    </>
  );
};

export default Gallery;